import { Client } from '@hashgraph/sdk';
import { NetworkConfig } from './types';

export function createClient(config: NetworkConfig | 'testnet' | 'mainnet'): Client {
  if (config === 'testnet') {
    return Client.forTestnet();
  }

  if (config === 'mainnet') {
    return Client.forMainnet();
  }

  const client = Client.forNetwork(config.nodes);
  client.setMirrorNetwork([config.mirrorNode]);
  client.setTransportSecurity(config.tls);

  return client;
}
